// extracted by mini-css-extract-plugin
module.exports = {"addressTable":"AddressTable_addressTable__MrAn8"};